import { Box, Container, Stack } from "@mui/material";
import { LogoImage } from "src/components/reusable/components/LogoImage";
import { useSSTheme } from "src/components/reusable/hooks/useSSTheme";
import { useTeamConfig } from "./TeamConfigProvider";
import { NavBarHamburgerMenu } from "./NavBarHamburgerMenu";

export interface NavigationBarProps {
  onClickLogo?: () => void;
  hideHamburgerMenu?: boolean;
}

export function NavigationBar(props?: NavigationBarProps) {
  const theme = useSSTheme();
  const { IMAGES } = useTeamConfig();

  return (
    <>
      <Stack
        id={"navigation-bar"}
        borderBottom={`1px solid ${theme.colors.border}`}
        position={"sticky"}
        top={0}
        bgcolor={theme.colors.background.white}
        zIndex={1000}
      >
        <Container maxWidth="lg">
          <Stack
            py={1}
            justifyContent={"space-between"}
            alignItems={"center"}
            direction={"row"}
          >
            <Box>
              <LogoImage onClick={props?.onClickLogo} src={IMAGES.LOGO_URL} />
            </Box>
            {!props?.hideHamburgerMenu ? (
              <Box>
                <NavBarHamburgerMenu />
              </Box>
            ) : null}
          </Stack>
        </Container>
      </Stack>
    </>
  );
}
